import React, { useEffect } from "react";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css"; // Import Date Range Picker CSS
import "bootstrap-daterangepicker"; // Import Date Range Picker JS
import ContentHeader from "../../../Components/ContentHeader/ContentHeader";
import Form from "../../../Components/Form/Form";
import AuditFormPrivew from "../../../Components/AuditFormPrivew/AuditFormPrivew";
import { FieldArray } from "formik";
import AuditFormSunQuestion from "../../../Components/AuditFormSubQuestion/AuditFormSunQuestion";
import AuditFormAnswerField from "../../../Components/AuditFormAnswerField/AuditFormAnswerField";

function CreateCenUi({
  formik,
  id,
  addNewOptionsField,
  handleCenChange,
  removeOptionsField,
  decodedToken,
  isOpetionError,
  disabled,
  handleSubQuestionChange,
  removeSubQuetionField,
  addNewSubQuetionField,
  addSubQuestonOptionField,
  removeSubQuestionOptionsField,
  handleSubQuetionsOptionsChange,
  subQuestionErrors,
  validateSubQuestions,
  setSubQuestionsErrors,
  callvalidation,
  toast,
}) {
  useEffect(() => {
    if (callvalidation !== "") {
      const error = validateSubQuestions(formik?.values);
      if (
        formik.values.input_type === "checkbox" &&
        formik.values.checkbox_type === "multiple" &&
        error?.sub_question?.length > 0
      ) {
        setSubQuestionsErrors(error?.sub_question);
      }
    }
  }, [callvalidation]);
  useEffect(() => {
    // Reset dependent fields when `input_type` changes
    if (!id) {
      const resetFields = () => {
        formik.setFieldValue("dropdown_type", "");
        formik.setFieldValue("checkbox_type", "");
        formik.setFieldValue("options", [""]);
        formik.setFieldValue("sub_question", [
          {
            question: "",
            input_type: "",
            dropdown_type: "",
            mandatory: "",
            multiline: "",
            checkbox_type: "",
            min: "",
            max: "",
            title: "",
            options: [""],
            answer: "",
          },
        ]);
        formik.setFieldValue("min", "");
        formik.setFieldValue("max", "");
        formik.setFieldValue("title", "");
        formik.setFieldValue("answer", [""]);
        formik.setFieldValue("multiline", false);
      };

      resetFields();
    }
  }, [formik.values.input_type]);
  useEffect(() => {
    // Reset dependent fields when `input_type` changes
    if (!id) {
      const resetFields = () => {
        formik.setFieldValue("options", [""]);
        formik.setFieldValue("min", "");
        formik.setFieldValue("max", "");
        formik.setFieldValue("title", "");
        formik.setFieldValue("answer", [""]);
      };
      resetFields();
    }
  }, [formik.values.dropdown_type]);
  useEffect(() => {
    if (formik?.values.checkbox_type !== "multiple") {
      formik.setFieldValue("mandatory", false);
    }
  }, [formik?.values.checkbox_type]);
  return (
    <div className="content-wrapper" style={{ minHeight: "100vh" }}>
      {/* Content Header */}
      <ContentHeader
        title={
          disabled
            ? "View Audit Question"
            : id
            ? "Update Audit Question"
            : "Create Audit Question"
        }
        buttonName={""}
        buttonBoolean={false}
        pageName={
          disabled
            ? "View Audit Question"
            : id
            ? "Update Audit Question"
            : "Create Audit Question"
        }
        backButton={true}
      />
      {/* Main Content */}
      <div style={{ padding: "0.8rem" }}>
        <Form
          formik={formik}
          submitDisplayNone={disabled}
          gridNot={true}
          toast={toast}
        >
          <div>
            <div className="row">
              <div className="col-8">
                <div className="form-group">
                  <label htmlFor="question">Question</label>
                  <input
                    type="text"
                    name="question"
                    disabled={disabled}
                    className={`form-control ${
                      formik.errors.question && formik.touched.question
                        ? "is-invalid"
                        : ""
                    }`}
                    id="question"
                    placeholder="Enter Question"
                    {...formik.getFieldProps("question")}
                  />
                  {formik.errors.question && formik.touched.question && (
                    <span className="invalid-feedback">
                      {formik.errors.question}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-4">
                <div className="form-group">
                  <label htmlFor="reference_para">
                    Reference Para of Tender Document
                  </label>
                  <input
                    type="text"
                    name="reference_para"
                    className={`form-control ${
                      formik.errors.reference_para &&
                      formik.touched.reference_para
                        ? "is-invalid"
                        : ""
                    }`}
                    id="reference_para"
                    min={0}
                    placeholder="Enter Reference Para"
                    {...formik.getFieldProps("reference_para")}
                  />
                  {formik.errors.reference_para &&
                    formik.touched.reference_para && (
                      <span className="invalid-feedback">
                        {formik.errors.reference_para}
                      </span>
                    )}
                </div>
              </div>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="input_type">Input Type</label>
                <div>
                  <select
                    id="input_type"
                    className={`w-100 p-2 select_css ${
                      disabled && "bg-disabled"
                    } ${
                      formik.errors.input_type && formik.touched.input_type
                        ? "is-invalid border-danger"
                        : ""
                    }`}
                    {...formik.getFieldProps("input_type")}
                  >
                    <option value="">Select Input Type</option>
                    <option value="text">Text</option>
                    <option value="dropdown">Dropdown</option>
                    <option value="checkbox">Checkbox</option>
                    <option value="radio">Radio</option>
                    <option value="date">Date</option>
                  </select>
                  {formik.errors.input_type && formik.touched.input_type && (
                    <span className="invalid-feedback">
                      {formik.errors.input_type}
                    </span>
                  )}
                </div>
              </div>
              <div className="form-grid">
                {formik?.values.checkbox_type !== "multiple" ? (
                  <div className="form-group mt-4">
                    {/* <label htmlFor="mandatory">Mandatory</label> */}
                    <div className="form-check">
                      <input
                        id="mandatory"
                        className="form-check-input form-control"
                        type="checkbox"
                        // disabled={disabled}
                        // {...formik.getFieldProps("mandatory")}
                        checked={formik.values.mandatory} // Bind to Formik's value
                        onChange={
                          (e) =>
                            formik.setFieldValue("mandatory", e.target.checked) // Update value based on 'checked'
                        }
                      />
                      <label className="form-check-label">Mandatory</label>
                    </div>
                    {formik.errors.mandatory && formik.touched.mandatory && (
                      <span className="invalid-feedback">
                        {formik.errors.mandatory}
                      </span>
                    )}
                  </div>
                ) : null}
                {formik?.values?.input_type == "text" ? (
                  <div className="form-group mt-4">
                    {/* <label htmlFor="multiline">Multiline</label> */}
                    <div className="form-check">
                      <input
                        id="multiline"
                        className="form-check-input form-control"
                        type="checkbox"
                        // {...formik.getFieldProps("multiline")}
                        checked={formik.values.multiline} // Bind to Formik's value
                        onChange={
                          (e) =>
                            formik.setFieldValue("multiline", e.target.checked) // Update value based on 'checked'
                        }
                      />
                      <label className="form-check-label">Multiline</label>
                    </div>
                    {formik.errors.multiline && formik.touched.multiline && (
                      <span className="invalid-feedback">
                        {formik.errors.multiline}
                      </span>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-grid">
              {formik?.values?.input_type !== "radio" && (
                <div>
                  {formik?.values?.input_type == "dropdown" ? (
                    <div className="form-group">
                      <label htmlFor="dropdown_type">Dropdown Type</label>
                      <div>
                        <select
                          id="dropdown_type"
                          disabled={disabled}
                          className={`w-100 p-2 select_css ${
                            disabled && "bg-disabled"
                          } ${
                            formik.errors.dropdown_type &&
                            formik.touched.dropdown_type
                              ? "is-invalid border-danger"
                              : ""
                          }`}
                          {...formik.getFieldProps("dropdown_type")}
                        >
                          <option value="">Select Dropdown Type</option>
                          <option value="numeric">Numeric</option>
                          <option value="custom">Custom</option>
                          <option value="autogenerate">Auto Generate</option>
                        </select>
                        {formik.errors.dropdown_type &&
                          formik.touched.dropdown_type && (
                            <span className="invalid-feedback">
                              {formik.errors.dropdown_type}
                            </span>
                          )}
                      </div>
                    </div>
                  ) : null}
                  {formik?.values?.input_type == "checkbox" ? (
                    <div className="form-group">
                      <label htmlFor="checkbox_type">Checkbox Type</label>
                      <div>
                        <select
                          id="checkbox_type"
                          name="checkbox_type"
                          className={`w-100 p-2 select_css  ${
                            formik.errors.checkbox_type &&
                            formik.touched.checkbox_type
                              ? "is-invalid border-danger"
                              : ""
                          }`}
                          {...formik.getFieldProps("checkbox_type")}
                        >
                          <option value="">Select Checkbox Type</option>
                          <option value="single">Single</option>
                          <option value="multiple">multiple</option>
                        </select>
                        {formik.errors.checkbox_type &&
                          formik.touched.checkbox_type && (
                            <span className="invalid-feedback">
                              {formik.errors.checkbox_type}
                            </span>
                          )}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
              {formik?.values?.input_type == "radio" ||
              formik?.values?.dropdown_type == "custom" ||
              formik?.values?.checkbox_type == "single" ? (
                <div className="form-group">
                  <label htmlFor="options">Options</label>
                  <div>
                    {formik?.values?.options?.map((cen, index) => (
                      <div key={index}>
                        <div className="d-flex align-items-center mb-2">
                          <input
                            type="text"
                            name={`options[${index}]`}
                            value={cen}
                            disabled={disabled}
                            placeholder="Enter Options"
                            className="form-control mr-2"
                            onChange={(e) =>
                              handleCenChange(index, e.target.value)
                            }
                            onInput={(e) => {
                              const value = e.target.value;
                              e.target.value = value.slice(0, 25); // Limit to 10 digits
                            }}
                          />
                          {/* {!id && ( */}
                          <>
                            {formik?.values?.options?.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => removeOptionsField(index)}
                              >
                                -
                              </button>
                            )}
                            {index === formik.values.options.length - 1 && (
                              <button
                                type="button"
                                className="btn btn-success ml-2"
                                onClick={addNewOptionsField}
                              >
                                +{" "}
                              </button>
                            )}
                          </>
                          {/* )} */}
                        </div>
                        {/* {formik.errors.cens && formik.touched.cens && ((isArray(formik.errors?.cens) && index in formik.errors?.cens) || (!isArray(formik.errors?.cens) && formik.errors?.cens))&& (
                                <div className="select-error">{isArray(formik.errors?.cens) ? formik.errors?.cens[index] : formik.errors?.cens}</div>
                            )} */}
                      </div>
                    ))}
                    <div className="select-error">{isOpetionError}</div>
                  </div>
                </div>
              ) : null}
              {formik?.values.dropdown_type == "numeric" &&
              formik?.values?.input_type == "dropdown" ? (
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="min">Min</label>
                    <input
                      type="number"
                      name="min"
                      disabled={disabled}
                      className={`form-control ${
                        formik.errors.min && formik.touched.min
                          ? "is-invalid"
                          : ""
                      }`}
                      id="min"
                      min={1} // Set HTML min attribute to 1
                      placeholder="Enter Min"
                      {...formik.getFieldProps("min")}
                      onChange={(e) => {
                        const value = parseInt(e.target.value, 10);
                        if (value > 0 || e.target.value === "") {
                          formik.setFieldValue("min", e.target.value);
                        }
                      }}
                    />

                    {formik.errors.min && formik.touched.min && (
                      <span className="invalid-feedback">
                        {formik.errors.min}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="max">Max</label>
                    <input
                      type="number"
                      name="max"
                      disabled={disabled}
                      className={`form-control ${
                        formik.errors.max && formik.touched.max
                          ? "is-invalid"
                          : ""
                      }`}
                      id="max"
                      min={0}
                      placeholder="Enter Max"
                      {...formik.getFieldProps("max")}
                    />
                    {formik.errors.max && formik.touched.max && (
                      <span className="invalid-feedback">
                        {formik.errors.max}
                      </span>
                    )}
                  </div>
                </div>
              ) : null}
              {formik?.values.dropdown_type == "autogenerate" &&
              formik?.values?.input_type == "dropdown" ? (
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <input
                      type="text"
                      name="title"
                      disabled={disabled}
                      className={`form-control ${
                        formik.errors.title && formik.touched.title
                          ? "is-invalid"
                          : ""
                      }`}
                      id="title"
                      placeholder="Enter title"
                      {...formik.getFieldProps("title")}
                    />
                    {formik.errors.title && formik.touched.title && (
                      <span className="invalid-feedback">
                        {formik.errors.title}
                      </span>
                    )}
                  </div>
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="min">Min</label>
                      <input
  type="number"
  name="min"
  disabled={disabled}
  className={`form-control ${
    formik.errors.min && formik.touched.min ? "is-invalid" : ""
  }`}
  id="min"
  min={1} // Set HTML min attribute to 1
  placeholder="Enter Min"
  {...formik.getFieldProps("min")}
  onChange={(e) => {
    const value = parseInt(e.target.value, 10);
    if (value > 0 || e.target.value === "") {
      formik.setFieldValue("min", e.target.value);
    }
  }}
/>

                      {formik.errors.min && formik.touched.min && (
                        <span className="invalid-feedback">
                          {formik.errors.min}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="max">Max</label>
                      <input
                        type="number"
                        name="max"
                        disabled={disabled}
                        className={`form-control ${
                          formik.errors.max && formik.touched.max
                            ? "is-invalid"
                            : ""
                        }`}
                        id="max"
                        min={0}
                        placeholder="Enter Max"
                        {...formik.getFieldProps("max")}
                      />
                      {formik.errors.max && formik.touched.max && (
                        <span className="invalid-feedback">
                          {formik.errors.max}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {formik?.values.checkbox_type == "multiple" ? (
              <>
                <label htmlFor="question">Sub Questions</label>
                <AuditFormSunQuestion
                  formik={formik}
                  handleSubQuestionChange={handleSubQuestionChange}
                  removeSubQuetionField={removeSubQuetionField}
                  addNewSubQuetionField={addNewSubQuetionField}
                  addSubQuestonOptionField={addSubQuestonOptionField}
                  removeSubQuestionOptionsField={removeSubQuestionOptionsField}
                  handleSubQuetionsOptionsChange={
                    handleSubQuetionsOptionsChange
                  }
                  subQuestionErrors={subQuestionErrors}
                  id={id}
                />
              </>
            ) : null}
            {/* {formik?.values.input_type !== "" &&
          formik?.values.input_type !== null &&
          formik?.values.checkbox_type !== "multiple" ? (
            <div className="form-group">
              <label htmlFor="answer">
                {formik?.values.input_type !== "" ? "Answer" : ""}
              </label>
              <AuditFormAnswerField values={formik?.values} formik={formik} />
            </div>
          ) : null} */}
          </div>
        </Form>
      </div>
      <div style={{ padding: "0.8rem" }}>
        <div
          className=" mt-1 p-3 card"
          // style={{ backgroundColor: "#dfdfdf", borderRadius: "10px" }}
        >
          <AuditFormPrivew values={formik.values} />
        </div>
      </div>
    </div>
  );
}

export default CreateCenUi;
